var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 10a4 4 0 1 1 0 8 4 4 0 0 1 0-8ZM4 10a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm7.299-5.543.087.089 1.93 2.232 2.048.708a1 1 0 0 1 .65 1.16l-.031.112a1 1 0 0 1-1.16.65l-.112-.031-2.302-.796a1 1 0 0 1-.337-.197l-.092-.094-1.387-1.603-1.891 1.982 2.046 2.274a1 1 0 0 1 .25.547l.007.122v4.24a1 1 0 0 1-1.993.117l-.007-.117-.001-3.857-2.408-2.676a1 1 0 0 1-.063-1.26l.082-.099 3.29-3.45a1 1 0 0 1 1.394-.053ZM16 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm9.5-10a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.1936a6eaee71b8af07ed4493f88dd720.svg";
export { ForwardRef as ReactComponent };